<template>
  <div>
    <div class="ui form" ref="form">
      <div class="field">
        <label for>{{ $t("authentication") }}</label>
        <select
          class="ui selection dropdown"
          ref="auth_dropdown"
          name="authentication"
          v-model="setup.authentication"
        >
          <option value>{{ $t("select one") }}</option>
          <option value="none">{{ $t("none") }}</option>
          <option value="basic">{{ $t("basic") }}</option>
          <option value="jwt">{{ $t("jwt") }}</option>
          <option value="dynamic_jwt">{{ $t("dynamic jwt") }}</option>
        </select>
      </div>
      <div class="ui error message"></div>
    </div>
    <basic-authentication
      :endpoint_in="endpoint_in"
      v-if="setup.authentication == 'basic'"
      style="padding-left:0;padding-right:0"
      ref="basic_auth"
    />
    <jwt-authentication
      :endpoint_in="endpoint_in"
      v-if="setup.authentication == 'jwt'"
      style="padding-left:0;padding-right:0"
      ref="jwt_auth"
    />
    <dynamic-jwt-authentication
      :endpoint_in="endpoint_in"
      v-if="setup.authentication == 'dynamic_jwt'"
      style="padding-left:0;padding-right:0"
      ref="dynamic_jwt_auth"
    />
  </div>
</template>

<script>
import { isEmpty } from "lodash";
import BasicAuthentication from "./BasicAuthentication";
import JwtAuthentication from "./JwtAuthentication";
import DynamicJwtAuthentication from "./DynamicJwtAuthentication";

export default {
  name: "Security",
  components: {
    BasicAuthentication,
    JwtAuthentication,
    DynamicJwtAuthentication,
  },
  props: {
    endpoint_in: Object,
  },
  computed: {},
  data() {
    return {
      setup: {
        authentication: "none",
      },
    };
  },
  methods: {
    getData() {
      if (this.setup.authentication == "basic")
        this.setup.basic_authentication_users = this.$refs.basic_auth.getData();
      if (this.setup.authentication == "jwt") {
        let data = this.$refs.jwt_auth.getData();
        this.setup.jwt_key = data.key;
        this.setup.jwt_token_name = data.name;
        this.setup.jwt_algorithm = data.algorithm;
        this.setup.tokens = data.tokens;
      }
      if (this.setup.authentication == "dynamic_jwt") {
        let data = this.$refs.dynamic_jwt_auth.getData();
        this.setup.jwt_key = data.key;
        this.setup.jwt_token_name = data.name;
      }

      return this.setup;
    },
    isValid() {
      return window.jQuery(this.$refs.form).form("validate form");
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(".ui.dropdown").dropdown();

    window.jQuery(vm.$refs.form).form({
      fields: {
        authentication: ["empty"],
      },
    });

    if (!isEmpty(this.endpoint_in)) {
      window
        .jQuery(vm.$refs.auth_dropdown)
        .dropdown(
          "set selected",
          this.endpoint_in.setup.security.authentication,
        );
    }
  },
  created() {},
  watch: {},
  updated: function() {},
};
</script>
